import React from 'react';
import styled from 'styled-components';
import { useI18n } from '../i18n/index';
import { theme } from '../styles/theme';

const LANGS = [
  { code: 'uz', labelKey: 'language.uzbek', testId: 'lang-switcher-uz' },
  { code: 'ru', labelKey: 'language.russian', testId: 'lang-switcher-ru' },
  { code: 'en', labelKey: 'language.english', testId: 'lang-switcher-en' },
];

const LanguageSwitcher = () => {
  const { locale, setLocale, t } = useI18n();

  return (
    <Nav aria-label={t('language.label')}>
      <Label>{t('language.label')}</Label>
      <Buttons role="group" aria-label={t('language.label')}>
        {LANGS.map(({ code, labelKey, testId }) => (
          <LangButton
            key={code}
            type="button"
            data-testid={testId}
            active={locale === code ? 1 : 0}
            aria-pressed={locale === code}
            onClick={() => setLocale(code)}
            title={t(labelKey)}
          >
            {t(labelKey)}
          </LangButton>
        ))}
      </Buttons>
    </Nav>
  );
};

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.mobile}) {
    gap: ${theme.spacing.xs};
  }
`;

const Label = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};

  @media (max-width: ${theme.breakpoints.mobile}) {
    display: none;
  }
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  background: ${theme.colors.backgroundPrimary};
  border: 1px solid ${theme.colors.borderStrong};
  border-radius: ${theme.radius.full};
  padding: 2px;
`;

const LangButton = styled.button`
  font-size: 11px;
  font-weight: ${({ active }) => (active ? '700' : '500')};
  letter-spacing: 0.3px;
  padding: 4px 10px;
  border-radius: ${theme.radius.full};
  transition: background 0.15s ease, color 0.15s ease;
  min-height: 28px;
  white-space: nowrap;

  background: ${({ active }) =>
    active ? theme.colors.skyBlue : 'transparent'};
  color: ${({ active }) =>
    active ? '#fff' : theme.colors.textSecondary};

  &:hover {
    color: ${({ active }) => (active ? '#fff' : theme.colors.textPrimary)};
    background: ${({ active }) =>
      active ? theme.colors.skyBlue : theme.colors.surfaceElevated};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.skyBlue};
    outline-offset: 2px;
  }
`;

export default LanguageSwitcher;
